import axios from '../http'

function query(data) {
    return axios.post('/sys/reportTemplate/query', data);
}

function get(id) {
    return axios.get('/sys/reportTemplate/get?id=' + id);
}

function add(data) {
    return axios.post('/sys/reportTemplate/add', data);
}

function update(data) {
    return axios.post('/sys/reportTemplate/update', data);
}

function del(id) {
    return axios.post('/sys/reportTemplate/del?id=' + id);
}

function importExcel(file){
    let formData = new FormData();
    formData.append("file", file);
    return axios.post("/sys/reportTemplate/importExcel", formData, {headers: {"Content-type": "multipart/form-data"}});
    
}

function exportExcel(data){
    const url =  "/sys/reportTemplate/exportExcel";
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Report Template "+ (new Date()).valueOf() +".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

export default {
    query,
    get,
    add,
    update,
    del,
    exportExcel,
    importExcel
}